import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { ContactList } from '../../features/contacts/components/contact-list';
import { Contact } from '../../app/entities/contact';
import { uiStore } from '../../core/stores/ui-store';
import { FloatingActionButton } from '../../components/buttons/floating-action-button';
import { CreateContactDrawer } from '../../features/contacts/components/create-contact.drawer';
import { ScreenContainer } from '../../features/projects/components/styled-project-components';

type MobileContactsListScreenProps = {
  contacts: Contact[];
  spaceId: string;
};

export const MobileContactsListScreen: React.FC<MobileContactsListScreenProps> = ({
  contacts,
  spaceId,
}) => {
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Contacts',
    };

    uiStore.showBack = false;
  }, []);

  const selectCreatedContact = (contact: Contact) => {
    navigate(`../${contact._id}`);
  };

  return (
    <Container>
      <ContactList contacts={contacts} />

      <FloatingActionButton onClick={() => setIsCreateModalOpen(true)} />

      {isCreateModalOpen && (
        <CreateContactDrawer
          spaceId={spaceId!}
          onCancel={() => setIsCreateModalOpen(false)}
          onSubmit={selectCreatedContact}
        />
      )}
    </Container>
  );
};

const Container = styled(ScreenContainer)`
  width: 100%;
  padding: 0 1.6rem;
  overflow-y: auto;
`;
